<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <div class="px-8 py-8 bg-white">
      <Varbox />
    </div>
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import Varbox from "./components/Varbox.vue";
export default {
  components: { Banner, Varbox },
};
</script>
